import { render, staticRenderFns } from "./cardmeber.vue?vue&type=template&id=10de941d&scoped=true&"
import script from "./cardmeber.vue?vue&type=script&lang=js&"
export * from "./cardmeber.vue?vue&type=script&lang=js&"
import style0 from "./cardmeber.vue?vue&type=style&index=0&id=10de941d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10de941d",
  null
  
)

export default component.exports